<div class="c06-end-screen" #endScreenRef [ngClass]="'on-' + featureName.toLowerCase() + '-page'">
  <div class="copy-wrapper" [ngClass]="{ 'voice-page': defaultButtons }">
    <h2 class="main-copy" aria-live="assertive">{{ copy[titleKey] }}</h2>
    <p class="secondary-copy" aria-live="assertive">{{ copy[copyKey] }}</p>
  </div>

  <div class="buttons-wrapper">
    <ng-container *ngFor="let button of pageButtons">
      <a
        *ngIf="button.link"
        [ngClass]="{ 'is-next': button.isNext }"
        class="endscreen-button"
        [routerLink]="button.link || undefined"
        [queryParams]="params"
        (click)="handleButtonClick(button.feature, button.callback)"
      >
        <span *ngIf="button.isChecked" class="check-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" fill="currentColor">
            <path
              d="m44.6 22.1-1.3 1.4c-4.6 4.9-9.6 10.4-14.2 15.3l-6.6-5.7-1.4-1.3-2.4 3 1.4 1.2 7.9 6.8 1.3 1.1 1.2-1.3c5-5.3 10.5-11.4 15.4-16.6l1.3-1.4-2.6-2.5z"
            />
          </svg>
        </span>
        <span
          [ngClass]="{ 'is-checked': button.isChecked, 'is-next': button.isNext }"
          class="button-copy"
          >{{ button.copy }}</span
        >
      </a>
      <button
        *ngIf="button.callback"
        class="endscreen-button"
        [ngClass]="{ 'is-next': button.isNext }"
        (click)="handleButtonClick(button.feature, button.callback)"
      >
        <span
          [ngStyle]="{
            'background-image': 'url(' + baseHref + '/assets/images/icons/restart.svg)'
          }"
          *ngIf="button.restart"
          class="restart-icon"
        ></span>
        <span class="button-copy">{{ button.copy }}</span>
      </button>
      <app-a02-comparison-button
        *ngIf="defaultButtons"
        [isVoicePage]="true"
        [location]="comapreButtonLocation.voiceSearch"
      ></app-a02-comparison-button>
    </ng-container>
  </div>
  <div *ngIf="!defaultButtons" class="compare-button-wrapper">
    <app-a02-comparison-button
      [location]="comapreButtonLocation.endScreen"
      [isSmall]="true"
    ></app-a02-comparison-button>
  </div>
</div>
